import { Injectable } from '@angular/core';

/**
 * Thin wrapper over the browser `localStorage` API. Kept as an injectable so
 * consumers depend on an abstraction (easy to mock/swap) rather than the global.
 */
@Injectable({ providedIn: 'root' })
export class LocalStorage {
  /**
   * Returns the number of key/value pairs.
   */
  get length(): number {
    return localStorage.length;
  }

  /**
   * Sets the value of the pair identified by key to value,
   * creating a new key/value pair if none existed for key previously.
   */
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  /**
   * Returns the current value associated with the given key,
   * or null if the given key does not exist.
   */
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  /**
   * Removes the key/value pair with the given key, if it exists.
   */
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Removes all key/value pairs, if there are any.
   */
  clear(): void {
    localStorage.clear();
  }

  /**
   * Returns the name of the nth key in the list.
   */
  key(index: number): string | null {
    return localStorage.key(index);
  }
}
